'use client';


import { Image } from '@akinon/next/components/image';
import { CategoryWithBanner } from '@theme/types';
import clsx from 'clsx';

export const CategoryBanner = (
  props: CategoryWithBanner['attributes']['banner']
) => {
  if (Object.keys(props).length === 0) {
    return null;
  }

  return (
    <div className="relative md:mx-0 md:mb-10 lg:mb-15">
      <Image
        src={props.kwargs.value.mobile_image.url}
        alt="Category Banner"
        width={370}
        height={280}
        imageClassName="w-full h-full"
        aspectRatio={370 / 280}
        sizes="370px"
        className="block md:hidden"
      />

      <Image
        src={props.kwargs.value.desktop_image.url}
        alt="Category Banner"
        width={1560}
        height={660}
        imageClassName="w-full h-full"
        aspectRatio={1560 / 660}
        sizes="1560px"
        className="hidden md:block"
      />

      <div 
        style={{
          color: props?.value?.text_color || "#FFFFFF",
        }}
        className={clsx([
          "absolute top-7.5 left-7.5 text-white flex flex-col space-y-4 3xl:top-16 3xl:left-15 3xl:space-y-9",
          props.value.position === "top-right" && "left-auto right-7.5 text-right 3xl:left-auto 3xl:right-15",
          props.value.position === "top-center" && "right-7.5 text-center 3xl:right-15",
          props.value.position === "bottom-center" && "top-auto bottom-7.5 right-7.5 text-center 3xl:top-auto 3xl:bottom-15 3xl:right-15",
          props.value.position === "bottom-right" && "top-auto bottom-7.5 left-auto right-7.5 text-right 3xl:top-auto 3xl:bottom-15 3xl:left-auto 3xl:right-15",
          props.value.position === "bottom-left" && "top-auto bottom-7.5 3xl:top-auto 3xl:bottom-15",
          props.value.position === "left" && "!top-1/2 -translate-y-1/2 !3xl:top-1/2",
          props.value.position === "right" && "!top-1/2 left-auto right-7.5 text-right -translate-y-1/2 !3xl:top-1/2 3xl:left-auto 3xl:right-15",
          props.value.position === "center" && "!top-1/2 right-7.5 text-center -translate-y-1/2 !3xl:top-1/2 3xl:right-15"
        ])}
      >
        {props.value.title && <h2 className="font-medium text-[2rem] leading-none 3xl:text-[3rem]">{props.value.title}</h2>}
        {props.value.tagline && <h3 className="text-xl leading-none 3xl:text-2xl">{props.value.tagline}</h3>}
      </div>
    </div>
  );
};
